import { FunctionalComponent } from 'vue'
import { Container, FolderKanban, Webhook } from 'lucide-vue-next'

export enum ComponentType {
    Transformer = 1,
    Turbine,
    Generator,
}

type ComponentTypeInfo = {
    labelKey: string
    lucideIcon: FunctionalComponent
}

export const ComponentTypesMap: Record<ComponentType, ComponentTypeInfo> = {
    [ComponentType.Transformer]: {
        labelKey: 'common.componentTypes.transformer',
        lucideIcon: Container,
    },
    [ComponentType.Turbine]: {
        labelKey: 'common.componentTypes.turbine',
        lucideIcon: Webhook,
    },
    [ComponentType.Generator]: {
        labelKey: 'common.componentTypes.generator',
        lucideIcon: FolderKanban,
    },
}

export const ComponentTypes = [
    {
        labelKey: ComponentTypesMap[ComponentType.Transformer].labelKey,
        value: ComponentType.Transformer,
        canViewData: (permissions: Record<string, boolean | undefined>) => permissions.canViewTransformerData ?? false,
        canViewRecommendations: (permissions: Record<string, boolean | undefined>) => permissions.canViewTransformerRecommendations ?? false,
        canViewReports: (permissions: Record<string, boolean | undefined>) => permissions.canViewTransformerReports ?? false,
        canExportReports: (permissions: Record<string, boolean | undefined>) => permissions.canExportTransformerReports ?? false,
    },
    {
        labelKey: ComponentTypesMap[ComponentType.Generator].labelKey,
        value: ComponentType.Generator,
        canViewData: (permissions: Record<string, boolean | undefined>) => permissions.canViewGeneratorsData ?? false,
        canViewRecommendations: (permissions: Record<string, boolean | undefined>) => permissions.canViewGeneratorRecommendations ?? false,
        canViewReports: (permissions: Record<string, boolean | undefined>) => permissions.canViewGeneratorReports ?? false,
        canExportReports: (permissions: Record<string, boolean | undefined>) => permissions.canExportGeneratorReports ?? false,
    },
] as const

export const getAllComponentsWithViewPermission = (permissions: Record<string, boolean | undefined>): ComponentType[] => {
    const allowedComponents: ComponentType[] = []
    for (const component of ComponentTypes) {
        switch (component.value) {
            case ComponentType.Transformer:
                if (permissions.canViewTransformerData) {
                    allowedComponents.push(component.value)
                }
                break
            case ComponentType.Generator:
                if (permissions.canViewGeneratorsData) {
                    allowedComponents.push(component.value)
                }
                break
        }
    }
    return allowedComponents
}

export const getAllowedComponentTypesForViewData = (permissions: Record<string, boolean | undefined>) => {
    return ComponentTypes.filter(c => c.canViewData(permissions))
}

export const getAllowedComponentTypesForViewRecommendations = (permissions: Record<string, boolean | undefined>) => {
    return ComponentTypes.filter(c => c.canViewRecommendations(permissions))
}

export const getAllowedComponentTypesForViewReports = (permissions: Record<string, boolean | undefined>) => {
    return ComponentTypes.filter(c => c.canViewReports(permissions))
}

export const getAllowedComponentTypesForExportReports = (permissions: Record<string, boolean | undefined>) => {
    return ComponentTypes.filter(c => c.canExportReports(permissions))
}
